import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';
import { FlightListScope } from '../overview/domain/constants/FlightListScope';
import { AirportCodes } from '../../../types/airports';

export function getFlightsListUrl(
	airport: AirportCodes,
	scope?: FlightListScope,
	query?: string,
) {
	const params =
		typeof window !== 'undefined'
			? new URLSearchParams(window.location.search)
			: new URLSearchParams();

	if (scope) {
		params.set('scope', scope);
	}

	if (query) {
		params.set('query', query);
	}

	if (query === '') params.delete('query');

	const queryString = params.toString() ? `?${params.toString()}` : '';

	const url = `/${airport}${PageRoutes.Flights}${queryString}`;

	return url;
}
